module.exports = __webpack_public_path__ + "img/1.893ca8d8.png";